import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgModule, ErrorHandler, CSP_NONCE } from '@angular/core';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthService } from './laas/auth.service';
import { BaseApi } from './laas/base-api.service';
import { GlobalErrorHandlerService } from './laas/global-error-handler.service';
import { DigireportComponent } from './digireport/digireport.component';
import { DependenciesModule } from './dependencies.module';
 
import { JwtModule } from '@auth0/angular-jwt';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { OpenDialogYesOrNo } from './landing/dialog-yes-or-no/dialog-yes-or-no.component';
import { InterceptorService } from './interceptor';
import { TokenServiceService } from './token-service.service';
import { InterceptorRespService } from './interceptor-resp';
import { EncryptionInterceptor } from './encryption-interceptor';
import { CryptoService } from './crypto.service';
import { NeslAggrementComponent } from './landing/mp-fresh-case/nesl-aggrement/nesl-aggrement.component';
 
export function tokenGetter() {
  return sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
};
 
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    PageNotFoundComponent,
    DigireportComponent,
    OpenDialogYesOrNo,
    NeslAggrementComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    DependenciesModule,
    MatDatepickerModule,
    MatIconModule,
    MatSelectModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatToolbarModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [],
        disallowedRoutes: []
      }
    }),
    ModalModule.forRoot()
  ],
  providers: [
    AuthService,
    BaseApi,
    Title,
    TokenServiceService,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorRespService, multi: true },
    CryptoService,
    BsModalService,
    TokenServiceService,
    // Popups dismiss only via their own buttons - a backdrop click or ESC must not close them.
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true } },
    // ── CSP Nonce — Angular 16 stamps this on all injected <style> tags ──
    {
      provide: CSP_NONCE,
      useFactory: () => {
        return document
          .querySelector('meta[name="ngCspNonce"]')
          ?.getAttribute('content') || '';
      }
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(mdIconRegistry: MatIconRegistry) {
    mdIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
}